<template>
  <v-skeleton-loader class="mensagem-boas-vindas" type="image" transition="fade-transition" :loading="$apollo.queries.welcome_message.loading">
    <v-card>
      <v-card-title class="pb-3">
        <span class="table-card-title px-0">Mensagem de Boas-vindas</span>

        <v-tooltip right max-width="300px">
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <mf-icon small class="ml-3 mb-1" color="cinza-0">info</mf-icon>
            </span>
          </template>
          <span
            >Neste campo você deve colocar a Mensagem de Boas-vindas que o seu Número de Disparo irá enviar quando receber a Mensagem Pré-digitada do seu
            cliente.</span
          >
        </v-tooltip>
      </v-card-title>
      <v-card-text>
        <v-textarea
          v-model="welcome_message"
          :background-color="!editing ? 'cinza-l90' : null"
          class="texto-corrido"
          :error-messages="welcomeMessageError"
          :disabled="!editing"
          height="80px"
          outlined
          no-resize
          maxlength="250"
          counter="250"
        />
        <mf-action-buttons
          v-if="editing"
          :primary-button="{
            text: 'Salvar',
            action: () => save(),
            isVisible: true,
            isLoading: $wait.is('update-welcome-message'),
          }"
          :cancel-button="{
            text: 'Cancelar',
            action: cancel,
            isVisible: true,
          }"
        />

        <div v-else class="d-flex justify-end py-3">
          <mf-button label="Editar" @click="startEdit" />
        </div>
      </v-card-text>
    </v-card>
  </v-skeleton-loader>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import gql from 'graphql-tag'
import { required } from 'vuelidate/lib/validators'
import { notOnlySpace } from '@/helpers/validators.js'

const QUERY_GET_MESSAGE_BY_TYPE = gql`
  query GetMessageByType {
    getMessageByType(type: WELCOME) {
      _id
      type
      text
    }
  }
`
const MUTATION_UPDATE_WELCOME_MESSAGE = gql`
  mutation UpdateMessageByType($text: String!) {
    updateMessageByType(type: WELCOME, text: $text) {
      _id
      type
      text
    }
  }
`

export default {
  data: () => ({
    welcome_message: '',
    backup_welcome_message: '',
    editing: false,
  }),
  computed: {
    welcomeMessageError() {
      if (this.$v.welcome_message.$error) {
        if (!this.$v.welcome_message.required) return 'Campo obrigatório.'
        else if (!this.$v.welcome_message.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      } else return ''
      return ''
    },
  },
  apollo: {
    welcome_message: {
      query: QUERY_GET_MESSAGE_BY_TYPE,
      update({ getMessageByType }) {
        return getMessageByType.text
      },
    },
  },
  methods: {
    startEdit() {
      this.backup_welcome_message = cloneDeep(this.welcome_message)
      this.editing = true
    },
    endEdit() {
      this.editing = false
    },
    cancel() {
      this.welcome_message = this.backup_welcome_message
      this.$v.$reset()
      this.endEdit()
    },
    async save() {
      try {
        this.$v.$reset()
        this.$v.$touch()
        if (this.$v.$error) {
          this.$snackbar({ message: 'Preencha todos os campos corretamente.', snackbarColor: 'error' })
          return
        }

        this.$wait.start('update-welcome-message')
        await this.$apollo.mutate({ mutation: MUTATION_UPDATE_WELCOME_MESSAGE, variables: { text: this.welcome_message } })
        this.$snackbar({ message: 'Mensagem atualizada', snackbarColor: 'success' })
        this.$wait.end('update-welcome-message')
        this.endEdit()
      } catch (error) {
        this.$snackbar({ message: 'Erro ao atualizar mensagem', snackbarColor: 'error' })
        this.cancel()
        this.$wait.end('update-welcome-message')
        this.endEdit()
      }
    },
  },
  validations() {
    return {
      welcome_message: { required, notOnlySpace },
    }
  },
}
</script>

<style lang="scss">
.mensagem-boas-vindas {
  .v-skeleton-loader__image {
    height: 300px;
  }
}
</style>
